import React, { useState } from 'react';
import {
  Box, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, IconButton, Button, MenuItem, Select, TextField,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useChallans, useUpsertChallan, useDeleteChallan } from '../../../hooks/useForm16';
import { SELECTED_MENU_PROPS } from '../../StyledComponents/StyledComponent';

const EMPTY_ROW = {
  quarter: 1, tds_amount: '', bsr_code: '', challan_serial_no: '', deposit_date: '',
};

export default function AnnexureBEditor({ partAId, onChanged }) {
  const { data: rows = [], refetch } = useChallans(partAId);
  const upsert = useUpsertChallan(partAId);
  const del = useDeleteChallan(partAId);
  const [draft, setDraft] = useState(EMPTY_ROW);

  const submit = () => {
    if (!draft.tds_amount) return;
    upsert.mutate({ ...draft, part_a: partAId }, {
      onSuccess: () => {
        setDraft(EMPTY_ROW);
        refetch();
        onChanged?.();
      },
    });
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>Annexure B — Challan deposits</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Quarter</TableCell>
              <TableCell align="right">TDS Amount</TableCell>
              <TableCell>BSR Code</TableCell>
              <TableCell>Challan Serial No.</TableCell>
              <TableCell>Deposit Date</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id}>
                <TableCell>Q{r.quarter}</TableCell>
                <TableCell align="right">{r.tds_amount}</TableCell>
                <TableCell>{r.bsr_code || '—'}</TableCell>
                <TableCell>{r.challan_serial_no || '—'}</TableCell>
                <TableCell>{r.deposit_date || '—'}</TableCell>
                <TableCell align="right">
                  <IconButton size="small" onClick={() => del.mutate(r.id, { onSuccess: () => { refetch(); onChanged?.(); } })}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell>
                <Select size="small" value={draft.quarter}
                  onChange={(e) => setDraft({ ...draft, quarter: e.target.value })} MenuProps={SELECTED_MENU_PROPS}>
                  {[1, 2, 3, 4].map((q) => <MenuItem key={q} value={q}>Q{q}</MenuItem>)}
                </Select>
              </TableCell>
              <TableCell align="right">
                <TextField size="small" type="number" value={draft.tds_amount}
                  onChange={(e) => setDraft({ ...draft, tds_amount: e.target.value })} />
              </TableCell>
              <TableCell>
                <TextField size="small" value={draft.bsr_code} inputProps={{ maxLength: 10 }}
                  onChange={(e) => setDraft({ ...draft, bsr_code: e.target.value })} />
              </TableCell>
              <TableCell>
                <TextField size="small" value={draft.challan_serial_no}
                  onChange={(e) => setDraft({ ...draft, challan_serial_no: e.target.value })} />
              </TableCell>
              <TableCell>
                <TextField size="small" type="date" InputLabelProps={{ shrink: true }}
                  value={draft.deposit_date}
                  onChange={(e) => setDraft({ ...draft, deposit_date: e.target.value })} />
              </TableCell>
              <TableCell align="right">
                <Button size="small" variant="contained" onClick={submit}>Add</Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
